import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
import { TextCountVariantType } from './variants';
export const getTextCountStyles = (FOUNDATIONS, FONT) => {
    return {
        [TextCountVariantType.DEFAULT]: {
            wrapper: {
                width: 'max-content',
                height: 'auto',
            },
            letfText: {
                font_variant: TextVariantType.FONT_PARAGRAPH_400,
                font_weight: FONT_WEIGHT.font_bold,
                color: FOUNDATIONS.color_neutral_font_150,
                disabled: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                    font_weight: FONT_WEIGHT.font_bold,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
            rightText: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_150,
                disabled: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
        },
    };
};
//# sourceMappingURL=styles.js.map